import errorReporter from '~/utils/AaaSentryIo';
import HashUtil from '~/utils/HashUtil';

let isInit = false;

const initWwwSession = async () => {
  if (import.meta.server) return;

  const { getCookieStringByName, setToSessionStorage, getFromSessionStorageOrNull } =
    useWwwStorage();

  // generate a fallback uid if cookie is not set
  const generateTempWwwSession = (): string => {
    const timeStr = new Date()
      .toISOString()
      .replace(/[^a-zA-Z0-9]/g, '-')
      .split('-')
      .slice(0, -1)
      .join('-');

    // attempt to generate a uid via the userAgent
    if (
      window.navigator &&
      window.navigator.userAgent &&
      typeof window.navigator.userAgent === 'string'
    ) {
      const hashUid = `tmp-hash-${timeStr}-${HashUtil.cyrb53(window.navigator.userAgent)}`;
      return hashUid;
    }

    // fallback to time-based uid
    const tmpUid = `tmp-time-${timeStr}`;
    return tmpUid;
  };

  const getWwwSession = () => {
    const localSession = getFromSessionStorageOrNull<string>({ key: 'WwwSession' });
    if (localSession) {
      return localSession;
    }

    const tempSession = generateTempWwwSession();
    setToSessionStorage({
      key: 'WwwSession',
      data: tempSession,
    });

    return tempSession;
  };

  // watch the x-www-session cookie and use it to set the user id in sentry
  watch(
    () => getCookieStringByName('x-www-session')?.value,
    (newVal) => {
      if (!newVal) {
        const tempUid = getWwwSession();
        errorReporter.setUser({ id: tempUid });
        return;
      }

      errorReporter.setUser({ id: newVal });
      setToSessionStorage({
        key: 'WwwSession',
        data: newVal,
      });
      return;
    },
    { immediate: true }
  );
};

export const useWwwSession = () => {
  if (!isInit) {
    isInit = true;
    initWwwSession();
  }
};
